const bundles = {
  // Storefront section (rendered inside the add-ons store)
  sectionTitle: 'Bundles',
  sectionSubtitle: 'Save more by buying add-ons together',
  // Dedicated /bundles page hero
  pageTitle: 'Bundles',
  pageSubtitle: 'Save more by buying add-ons together as a bundle',
  planDiscountNote: 'Your plan: −{{percent}}% on all bundles',
  empty: 'No bundles are available right now.',
  loadError: 'Failed to load bundles',
  whatsInside: "What's inside",
  itemLine: '{{name}} ×{{count}}',
  youSave: 'You save {{amount}} SAR',
  signInToBuy: 'Sign in to purchase bundles',

  // Audiences
  audience: {
    OWNER: 'Owner',
    BROKER: 'Broker',
    COMPANY: 'Company',
    ALL: 'Everyone',
  },

  // Discount kinds
  discountKind: {
    NONE: 'No discount',
    PERCENTAGE: 'Percentage',
    FIXED_SAR: 'Fixed (SAR)',
    COINS: 'Coins',
  },

  // Pricing
  priceSar: '{{price}} SAR',
  coinPrice: '{{count}} coins',
  free: 'Free',
  yourBalance: 'Your balance',

  // Buttons
  buy: 'Buy bundle',
  payWithCoins: 'Pay with coins',
  cancel: 'Cancel',

  // Toasts
  purchaseSuccess: 'Bundle purchased and activated successfully',
  payWithCoinsSuccess: 'Bundle activated. Coins deducted from your balance.',
  insufficientCoins: 'Not enough coins. Top up your balance and try again.',
  actionError: 'Something went wrong. Please try again.',

  // Admin: bundle builder / CRUD
  admin: {
    title: 'Bundles',
    subtitle: 'Build and manage add-on bundles',
    addBundle: 'Add bundle',
    editBundle: 'Edit bundle',
    createBundle: 'Create bundle',
    empty: 'No bundles yet. Create one to get started.',
    deleteConfirm:
      'Are you sure you want to delete "{{name}}"? If it has purchases it will be deactivated instead.',

    // Table columns
    colName: 'Name',
    colItems: 'Items',
    colDiscount: 'Discount',
    colAudiences: 'Audiences',
    colPrice: 'Price',
    colStatus: 'Status',
    colActions: 'Actions',
    colActive: 'Active',
    colInactive: 'Inactive',
    itemsCount_one: '{{count}} item',
    itemsCount_other: '{{count}} items',

    // Field labels
    fieldSlug: 'Slug',
    fieldSlugHint: 'Lowercase letters, numbers and underscores. Cannot be changed later.',
    fieldName: 'Name (English)',
    fieldNameAr: 'Name (Arabic)',
    fieldDescription: 'Description (English)',
    fieldDescriptionAr: 'Description (Arabic)',
    fieldAudiences: 'Audiences',
    fieldItems: 'Add-ons in this bundle',
    fieldItemsHint: 'Quote-based add-ons cannot be bundled and are not listed here.',
    fieldDiscount: 'Discount',
    fieldDiscountValue: 'Discount value',
    fieldDiscountValueHintPercentage: 'Percentage off the base price (0-100).',
    fieldDiscountValueHintFixed: 'Flat SAR amount off the base price.',
    fieldDiscountValueHintCoins: 'Coins to convert to a SAR discount at the current rate.',
    fieldActive: 'Active (visible in store)',
    fieldSortOrder: 'Sort order',
    addItem: 'Add add-on',
    quantity: 'Qty',
    remove: 'Remove',

    // Price preview
    previewTitle: 'Price preview',
    previewBase: 'Base price',
    previewDiscount: 'Discount',
    previewFinal: 'Final price',

    // Validation
    audiencesRequired: 'Select at least one audience',
    itemsRequired: 'Add at least one add-on to the bundle',
    noAddonsAvailable: 'No bundleable add-ons available. Create priced add-ons first.',

    // Buttons / toasts
    save: 'Save',
    saving: 'Saving...',
    createError: 'Failed to create bundle',
    updateError: 'Failed to update bundle',
    deleteError: 'Failed to delete bundle',
    slugExistsError: 'A bundle with this slug already exists.',
    quoteAddonError: 'A quote-based add-on cannot be put in a bundle.',
  },

  // Plan (custom-plan) embedding — used on the tiers admin page
  plan: {
    isCustom: 'Custom plan',
    isCustomHint: 'Bespoke deal - bundles add-ons and an extra discount.',
    discount: 'Discount',
    discountValue: 'Discount value',
    embeddedAddons: 'Embedded add-ons',
    embeddedAddonsHint: 'These add-ons are granted to the user when they subscribe.',
  },
  // The "includes special deals" line in BundleCard.
  specialDealsIncluded: 'Access to subscriber Special deals',
};

export default bundles;
